import { type Monitor, Signal } from "@suse-o11y/signal";

import { isEqualTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { isPresent } from "~/tools/is-present";
import type { Point } from "~/tools/point";

import { type TimelineEventBucket, type TimelineEventCategory, getTimelineEventBucketStartTime } from "./domain";

export interface TimelineHoveredEventBucket {
	eventCategory: TimelineEventCategory;
	bucket: TimelineEventBucket;
	position: Point;
}

export class TimelineEventBucketsState {
	private readonly bucketPopup = Signal<TimelineHoveredEventBucket>();
	public readonly hoveredBucket = Signal<TimelineHoveredEventBucket>();

	public getBucketPopup(monitor: Monitor): undefined | TimelineHoveredEventBucket {
		return this.hoveredBucket.read(monitor) ?? this.bucketPopup.read(monitor);
	}

	public setBucketPopup(event: undefined | TimelineHoveredEventBucket): void {
		this.bucketPopup.write(event);
	}

	public isBucketPopupHovered(monitor: Monitor): boolean {
		return isPresent(this.bucketPopup.read(monitor));
	}

	public isBucketHovered(monitor: Monitor, eventCategory: TimelineEventCategory, startTime: Time): boolean {
		const hovered = this.getBucketPopup(monitor);

		if (hovered?.eventCategory !== eventCategory) {
			return false;
		}

		return isEqualTime(getTimelineEventBucketStartTime(hovered.bucket), startTime);
	}
}
